import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { createContext, useContext } from "react";
import { cn } from "../../lib/utils";
import { toggleVariants } from "./toggle";

const ToggleGroupContext = createContext({ size: "default", variant: "default" });

export function ToggleGroup({ className, variant, size, children, ...props }) {
  return (
    <ToggleGroupPrimitive.Root className={cn("flex items-center justify-center gap-1", className)} {...props}>
      <ToggleGroupContext.Provider value={{ variant, size }}>{children}</ToggleGroupContext.Provider>
    </ToggleGroupPrimitive.Root>
  );
}

export function ToggleGroupItem({ className, children, variant, size, ...props }) {
  const context = useContext(ToggleGroupContext);
  return (
    <ToggleGroupPrimitive.Item className={cn(toggleVariants({ variant: context.variant || variant, size: context.size || size }), "min-w-0", className)} {...props}>
      {children}
    </ToggleGroupPrimitive.Item>
  );
}
